// extracted by mini-css-extract-plugin
export default {"SmallTable":"GameTeamComparison-module__SmallTable__TVwgP","LargeTable":"GameTeamComparison-module__LargeTable__GCFCP"};